import { render, staticRenderFns } from "./AnswerCheckbox.vue?vue&type=template&id=3c6209f6&scoped=true&"
import script from "./AnswerCheckbox.vue?vue&type=script&lang=js&"
export * from "./AnswerCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCheckbox.vue?vue&type=style&index=0&id=3c6209f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6209f6",
  null
  
)

export default component.exports